export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const getBase64FromUrl = async (url: string) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result);
  });
};

export const isBase64 = (str: string) => {
  if (str === "" || str.trim() === "") return false;
  try {
    window.atob(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const createCSV = (datosExport: any, fileName: string) => {
  var blob = new Blob([datosExport], { type: "text/csv;charset=utf-8;" });
  let Navigator = window.navigator as any;
  if (Navigator.msSaveBlob) {
    Navigator.msSaveBlob(blob, fileName + ".csv");
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName + ".csv");
      link.setAttribute("style", "visibility:hidden");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
